import React from 'react';
import { findDOMNode } from 'react-dom';
import { EVENT_NAME } from './constants';
import { track } from './callbacks';

class Provider extends React.Component {
  static defaultProps = {
    data: {},
  };

  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    this.node = findDOMNode(this);
    this.node && this.node.addEventListener(EVENT_NAME, this.onEvent);
  }

  componentWillUnmount() {
    this.node && this.node.removeEventListener(EVENT_NAME, this.onEvent);
  }

  onEvent = (event) => {
    track({ eventData: event.detail, sectionData: this.props.data });
    event.stopPropagation();
  };

  render() {
    return this.props.children;
  }
}

export default Provider;
